import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/dashboard.css";
import "./assets/css/dashboard-responsive.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./Layout";

import PageNotFound from "./Component/404/PageNotFound";

import Protected from "./Protected";
import Dashboard from "./Component/Home/Dashboard";
import Login from "./Component/Login/Login";
import ForgetPassword from "./Component/Login/ForgetPassword";
import UserList from "./Component/Users/UserList";
import UserEdit from "./Component/Users/UserEdit";
import Barcode from "./Component/Barcode/Barcode";
import BusList from "./Component/Bus/BusList";
import JobSchedule from "./Component/Rostering/JobSchedule";
import CompanyList from "./Component/Company/CompanyList";
import DepoList from "./Component/Depo/DepoList";
import CategoryList from "./Component/Category/CategoryList";
import SubCategoryList from "./Component/Subcategory/SubCategoryList";
import UserView from "./Component/Users/UserView";
import ReportList from "./Component/Report/ReportList";
import ReportView from "./Component/Report/ReportView";
import Analytics from "./Component/Analytics/Analytics";
import AssignTask from "./Component/Rostering/Assign_task";
import JobScheduleForm from "./Component/Rostering/JobScheduleForm";
import JobScheduleEdit from "./Component/Rostering/JobScheduleEdit";
import ChangeScheduling from "./Component/Rostering/ChangeScheduling";
import DepoListForChangeScheduling from "./Component/Rostering/DepoListForChangeScheduling";
import Demo from "./Component/Bus/Demo";
import ResetPassword from "./Component/Login/ResetPassword";
import PrivacyPolicy from "./Component/PrivacyPolicy";

// v---
import Chemicalcds from "./Component/ChemicalCds/ChemicalHome/Chemicalcds";
import AddCategory from "./Component/ChemicalCds/Category  not working/AddCategory";
import AddSubCatgory from "./Component/ChemicalCds/SubCategory/AddSubCatgory";
import ChemicalCategoryList from "./Component/ChemicalCds/Category  not working/ChemicalCategoryList";
import ChemiclSubCatList from "./Component/ChemicalCds/SubCategory/ChemiclSubCatList";
// import ForgetPassword from "./"

import HealthViewsetList from "./Component/healthViewset/HealthViewsetList";
import HealthViewsetAdd from "./Component/healthViewset/HealthViewsetAdd";
import HealthViewsetEdit from "./Component/healthViewset/HealthViewsetEdit";
import HealthPolicyPage from "./Component/healthViewset/HealthPolicyPage";

import HealthSafetyDocumentList from "./Component/ChemicalCds/HealthSafetyDocument/HealthSafetyDocumentList";
import { CampusView } from "./edu-component/campus/campus-view";
import { CollegeView } from "./edu-component/college/college-view";
import { EduUsersList } from "./edu-component/edu-users/edu-users-list";
import EduDashboard from "./edu-component/home/edu-dashboard";
import EduReportMgmt from "./edu-component/edu-report-mgmt/edu-report-mgmt";
import { JobScheduleView } from "./edu-component/edu-job-schedule/jobschedule-view";
import { JobScheduleCampus } from "./edu-component/edu-job-schedule/job-schedule-campus";
import { EduCompanyHome } from "./edu-component/company/edu-company-home";
import { EduHealthSafetyMgmt } from "./edu-component/edu-health-safety-mgmt/edu-health-safety-mgmt";
import {
  EduHealthSafetyDocumentList,
  HealthSafetyDocumentListEdu,
} from "./edu-component/edu-health-safety-mgmt/helper/edu-health-safety-document-list";
import { EduHealthSafetyPolicyList } from "./edu-component/edu-health-safety-mgmt/helper/edu-health-safety-policy-list";
import { EduChemicalSDSList } from "./edu-component/edu-health-safety-mgmt/helper/edu-chemical-sds-list";
import EduReportView from "./edu-component/edu-report-mgmt/edu-report-view";

function App() {
  let token = localStorage.getItem("token");

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<Protected Component={Dashboard} />} />
            <Route
              path="user-list"
              element={<Protected Component={UserList} />}
            />
            <Route
              path="User-edit/:modelType/:id"
              element={<Protected Component={UserEdit} />}
            />
            <Route
              path="User-view/:id"
              element={<Protected Component={UserView} />}
            />
            <Route path="barcode" element={<Protected Component={Barcode} />} />
            <Route
              path="bus-list"
              element={<Protected Component={BusList} />}
            />
            <Route
              path="job-scheduled"
              element={<Protected Component={JobSchedule} />}
            />
            <Route
              path="job-schedule"
              element={<Protected Component={AssignTask} />}
            />
            <Route
              path="/job-schedule-form"
              element={<Protected Component={JobScheduleForm} />}
            />
            <Route
              path="/job-schedule-edit/:id"
              element={<Protected Component={JobScheduleEdit} />}
            />
            <Route
              path="company-list"
              element={<Protected Component={CompanyList} />}
            />
            <Route
              path="depo-list"
              element={<Protected Component={DepoList} />}
            />
            <Route
              path="analytics"
              element={<Protected Component={Analytics} />}
            />
            <Route
              path="category-list"
              element={<Protected Component={CategoryList} />}
            />
            <Route
              path="subcategory-list"
              element={<Protected Component={SubCategoryList} />} // comment no working
            />
            <Route
              path="report-list"
              element={<Protected Component={ReportList} />}
            />
            <Route
              path="report-view/:id"
              element={<Protected Component={ReportView} />}
            />
            <Route
              path="depo-list-for-change-scheduling"
              element={<Protected Component={DepoListForChangeScheduling} />}
            />
            <Route
              path="change-scheduling/:id"
              element={<Protected Component={ChangeScheduling} />}
            />
            <Route path="demo" element={<Protected Component={Demo} />} />
            {/* *************vvv */}
            <Route
              path="chemicalcdslist"
              element={<Protected Component={Chemicalcds} />}
            />
            <Route
              path="chemicalcategorylist"
              element={<Protected Component={ChemicalCategoryList} />}
            />
            <Route
              path="chemicalsubcategorylist"
              element={<Protected Component={ChemiclSubCatList} />}
            />
            <Route
              path="addcategory"
              element={<Protected Component={AddCategory} />}
            />
            <Route
              path="addsubcategory"
              element={<Protected Component={AddSubCatgory} />}
            />
            <Route
              path="health-viewset-list"
              element={<Protected Component={HealthViewsetList} />}
            />
            <Route
              path="health-viewset-add"
              element={<Protected Component={HealthViewsetAdd} />}
            />
            <Route
              path="health-viewset-edit/:id"
              element={<Protected Component={HealthViewsetEdit} />}
            />
            <Route
              path="health-policy"
              element={<Protected Component={HealthPolicyPage} />}
            />
            <Route
              path="health-safety-document-list"
              element={<HealthSafetyDocumentList />}
            />
          </Route>

          <Route exact path="/education" element={<Layout />}>
            <Route
              exact
              index
              element={<Protected Component={EduDashboard} />}
            />
            <Route
              exact
              path="edu-users-list"
              element={<Protected Component={EduUsersList} />}
            />

            <Route
              exact
              path="edu-company-list"
              element={<Protected Component={EduCompanyHome} />}
            />
            {/* <Route
              exact
              path="campus-list"
              element={<Protected Component={CampusView} />}
            />
            <Route
              exact
              path="college-list"
              element={<Protected Component={CollegeView} />}
            /> */}
            <Route
              exact
              path="block-list"
              element={<Protected Component={CollegeView} />}
            />
            <Route
              exact
              path="college-list"
              element={<Protected Component={CampusView} />}
            />
            <Route
              exact
              path="edu-report-management"
              element={<Protected Component={EduReportMgmt} />}
            />
            <Route
              exact
              path="edu-job-schedule"
              element={<Protected Component={JobScheduleView} />}
            />
            <Route
              exact
              path="edu-job-schedule/campus"
              element={<Protected Component={JobScheduleCampus} />}
            />
            <Route
              exact
              path="chemicalcdslist"
              element={<Protected Component={EduHealthSafetyMgmt} />}
            />
            <Route
              exact
              path="chemicalcdslist/health-safety-document-list"
              element={<Protected Component={EduHealthSafetyDocumentList} />}
            />
            <Route
              exact
              path="chemicalcdslist/health-safety-policy-list"
              element={<Protected Component={EduHealthSafetyPolicyList} />}
            />
            <Route
              exact
              path="chemicalcdslist/edu-chemical-cds-list"
              element={<Protected Component={EduChemicalSDSList} />}
            />
            <Route
              exact
              path="report-view/:id"
              element={<Protected Component={EduReportView} />}
            />
          </Route>
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
